import React from 'react';
import { RendererContext } from '../../context';

export const useIsMacro = () => {
	const { extensionType } = React.useContext(RendererContext);
	return extensionType === 'xen:macro';
};
